<ng-template #stackList let-items>
  @for (item of items; track item.id) {
    <div
      class="stack-item"
      [class.stack-item--toast]="item.kind === itemKind.toast"
      [class.stack-item--notification]="item.kind === itemKind.notification"
      [class.show]="item.isShown"
      [style.z-index]="item.zIndex"
      (mouseenter)="pauseTimer(item)"
      (mouseleave)="resumeTimer(item)"
    >
      @switch (item.kind) {
        @case (itemKind.toast) {
          <loop-toast-card [toast]="item.toast" (closed)="close(item)" />
        }
        @case (itemKind.notification) {
          <loop-notification-card [notification]="item.notification" />
        }
      }
    </div>
  }
</ng-template>

<div class="stack-container stack-container--left">
  <ng-container *ngTemplateOutlet="stackList; context: { $implicit: leftItems() }" />
</div>
<div class="stack-container stack-container--right">
  <ng-container *ngTemplateOutlet="stackList; context: { $implicit: rightItems() }" />
</div>
<div class="stack-container stack-container--center">
  <ng-container *ngTemplateOutlet="stackList; context: { $implicit: centerItems() }" />
</div>
